import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';

import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  box-shadow: 0 0 5px 0 rgba(${ColorPalette.RGB.PineTree}, 0.15);
  -moz-box-shadow: 0 0 5px 0 rgba(${ColorPalette.RGB.PineTree}, 0.15);
  -webkit-box-shadow: 0 0 5px 0 rgba(${ColorPalette.RGB.PineTree}, 0.15);
  margin-top: 10px;
  border-radius: 8px;
  padding: 12px 16px;
  background-color: ${ColorPalette.HEX.White};

  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 0;
    margin-left: 1px;
    margin-right: 1px;
  }

  &.no-border {
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    background-color: ${ColorPalette.Transparent};
    padding: 12px;
    border-bottom: 1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25);
    border-radius: 0;
    margin-top: 0;
  }
`;

export const NameArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

interface NameProps {
  $active: boolean;
}

export const Name = styled.h5<NameProps>`
  color: ${({ theme }) => theme.filtersBottomSheet.color};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? '600' : 'normal')};
`;

const expandOrCollapseCss = css`
  color: ${({ theme }) => theme.filtersBottomSheet.icon} !important;
  font-size: 18px;
  margin-left: auto;
`;

export const Collapse = styled(IoIosArrowUp)`
  ${expandOrCollapseCss}
`;

export const Expand = styled(IoIosArrowDown)`
  ${expandOrCollapseCss}
`;

export const Content = styled.div``;
